import { smartDocParamCondition_DispositionType, smartDocParamCondition_WorkingDiagnosis } from '../../smart-doc-param-condition/index.js';
import { smartDocExternalParam_ParamKey_DispositionType, smartDocExternalParam_ParamKey_WorkingDiagnosisId } from '../external/param-key.js';
import { smartDocExternalParamType_API } from '../external/types.js';
export const getDynamicParamConditionOptions = (externalParam) => {
    switch (externalParam.subType) {
        case smartDocExternalParamType_API: {
            switch (externalParam.paramKey) {
                case smartDocExternalParam_ParamKey_WorkingDiagnosisId:
                    return [...smartDocParamCondition_WorkingDiagnosis];
                case smartDocExternalParam_ParamKey_DispositionType:
                    return [...smartDocParamCondition_DispositionType];
                default:
                    return [];
            }
        }
        default:
            return [];
    }
};
//# sourceMappingURL=consts.js.map